import { Address, L1ChainId, Wei } from '../../../types'
import { providers } from 'ethers'
import { AddressGas, isGasAddress, isZeroAddress } from '../../../utils/address'
import { isAddress } from '@ethersproject/address'
import { store } from '../../../store'
import { updateActionState } from '../../../store/app/actions'
import { Interface } from '@ethersproject/abi'
import { sendMulticall } from './index'
import { BigNumber } from '@ethersproject/bignumber'
import { Web3Provider } from '@ethersproject/providers'
import { EthereumBalances } from '../../../store/link/types'
import { updateEthereumBalances } from '../../../store/web3/actions'

export async function callEthereumBalanceOf({
  layerOneChainId,
  multicallAddress,
  provider,
  accountAddress,
  tokenAddresses,
}: {
  layerOneChainId: L1ChainId
  multicallAddress: Address
  provider: providers.JsonRpcProvider
  accountAddress: Address
  tokenAddresses: Address[]
}) {
  if (!multicallAddress) {
    return
  }
  if (!provider) {
    return
  }
  const balanceOfAbi = ['function balanceOf(address) view returns (uint256)']
  const hasGasToken = tokenAddresses.filter((v) => isGasAddress(v))

  const erc20Addresses = tokenAddresses.filter(
    (address) =>
      isAddress(address) && !isGasAddress(address) && !isZeroAddress(address),
  )
  let balances: Wei[] = []
  store.dispatch(
    updateActionState({
      action: 'ethereumBalancesPulling',
      state: true,
    }),
  )

  if (erc20Addresses.length) {
    try {
      const iface = new Interface(balanceOfAbi)
      const fragment = iface.getFunction('balanceOf')
      const call = iface.encodeFunctionData(fragment, [accountAddress])
      const calls = erc20Addresses.map(() => call)
      const { decode } = await sendMulticall<BigNumber>(
        provider as Web3Provider,
        multicallAddress,
        erc20Addresses,
        calls,
      )

      balances = decode(iface, fragment).map((v) => v.toString())
    } catch (e) {
      console.error(e)
    }
  }

  const update: EthereumBalances = {
    [layerOneChainId]: {},
  }

  if (hasGasToken) {
    update[layerOneChainId][AddressGas.toLowerCase()] = (
      await provider.getBalance(accountAddress)
    ).toString()
  }
  erc20Addresses.forEach((v, i) => {
    update[layerOneChainId][v.toLowerCase()] = balances[i]
  })

  store.dispatch(
    updateEthereumBalances({
      ethereumBalances: update,
    }),
  )
  store.dispatch(
    updateActionState({
      action: 'ethereumBalancesPulling',
      state: false,
    }),
  )
}
